import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import ProductPrice from '../ProductPrice';
var useStyles = makeStyles({
  root: {},
  price: {}
}, {
  name: 'SxComProductListItemPrice'
});

function ProductListItemPrice(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      fullWidth = _ref.fullWidth,
      price = _ref.price,
      priceOriginal = _ref.priceOriginal,
      product = _ref.product,
      ProductPriceProps = _ref.ProductPriceProps,
      renderToGridArea = _ref.renderToGridArea,
      rest = _objectWithoutProperties(_ref, ["children", "classes", "className", "currency", "fullWidth", "price", "priceOriginal", "product", "ProductPriceProps", "renderToGridArea"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement(GridAreaContainer, _extends({
    className: clsx(classes.root, className),
    renderToGridArea: renderToGridArea
  }, rest), /*#__PURE__*/React.createElement(ProductPrice, _extends({}, ProductPriceProps, {
    className: classes.price,
    currency: currency,
    price: price,
    priceOriginal: priceOriginal,
    product: product,
    fullWidth: true
  }), children));
}

ProductListItemPrice.propTypes = {
  children: PropTypes.func,
  classes: PropTypes.shape({
    price: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  currency: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  price: PropTypes.number,
  priceOriginal: PropTypes.number,
  product: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  ProductPriceProps: PropTypes.shape({}),
  renderToGridArea: PropTypes.string
};
ProductListItemPrice.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  fullWidth: false,
  price: undefined,
  priceOriginal: undefined,
  product: undefined,
  ProductPriceProps: undefined,
  renderToGridArea: 'price'
};
export default ProductListItemPrice;